// extracted by mini-css-extract-plugin
export default {"Loading":"PDFPreviewer_Loading__4kKXe"};